<div
  apFoxitViewer
  rendererName="sign"
  [afterCreate]="afterCreateRenderer"
></div>
